export function getDocuments(props) {
    const { i9 } = props;
    if (!i9 || !i9.worker_i9_fields) {
        return [];
    }

    const { A, B, C, listAChoice, listBChoice, listCChoice } = i9.worker_i9_fields;

    if (A) {
        return [{ type: listAChoice, properties: { ...A } }];
    }

    if (B && C) {
        return [{ type: listBChoice, properties: { ...B } }, { type: listCChoice, properties: { ...C } }];
    }

    return [];
}

export const DOC_LIST_TYPES = {
    A: ['US_PASSPORT', 'US_PASSPORT_CARD', 'FORM_I-551', 'FPASS_W_I-551', 'FORM_I-766', 'NONIMMIGRANT_ALIEN'],
    B: [
        'DRIVERS_LICENSE_ID_CARD',
        'STATE_ID',
        'FEDERAL_ID_CARD',
        'SCHOOL_ID_CARD',
        'VOTERS_REGISTRATION_CARD',
        'US_MILITARY_CARD',
        'MILITARY_DEPENDENT_CARD',
        'COAST_GUARD_CARD',
        'NATIVE_AMERICAN_DOC',
        'CANADIAN_DRIVERS_LICENSE',
        'SCHOOL_REPORT',
        'HOSPITAL_RECORD',
        'NURSERY_RECORD'
    ],
    C: [
        'SSN_CARD',
        'REPORT_OF_BIRTH_FS240',
        'REPORT_OF_BIRTH_DS1350',
        'REPORT_OF_BIRTH_FS545',
        'BIRTH_CERTIFICATE',
        'NATIVE_AMERICAN_DOC',
        'CITIZEN_CARD_FORM_I-197',
        'RESIDENT_CARD_FORM_I-197',
        'EMPLOYEMENT_AUTH_HS'
    ]
};



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/utilities.jsx